/**
 * makeUrlSelector
 * the selector indicates the location in redux, is different for staff and employees
 * For creating/updating/deleting the backend uses 'employees' in both cases
 * @param {*} typeName
 * @param {*} userId
 * @returns
 */
function makeUrlSelector(typeName, userId) {
  const postFix = userId ? `/${userId}` : '';
  return {
    url: `sa/users/${typeName === 'staff' ? 'employee' : typeName}${postFix}`,
    selector: `sa/users/${typeName}${postFix}`,
  };
}

export default makeUrlSelector;
